import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const lineItemTypesAdapter = getAdapter();

const lineItemTypesSlice = createSlice({
    name: 'lineItemTypes',
    initialState: lineItemTypesAdapter.getInitialState(),
    reducers: {
        setLineItemTypes: (state, { payload: { lineItemTypes } }) => {
            lineItemTypesAdapter.setAll(state, lineItemTypes);
        },
    },
});

const selectors = lineItemTypesAdapter.getSelectors(({ lineItemTypes }) => lineItemTypes);

export const getAlllineItemTypes = (state) => selectors.selectAll(state);

export const {
    setLineItemTypes,
} = lineItemTypesSlice.actions;

export default lineItemTypesSlice.reducer;
